import {useProject} from "../Context/ProjectContext";
import OperationManager, {OPS_STATUS} from "../Components/OperationManager";
import {Button, Card, Divider, Select, Typography} from "antd";
import ProjectInfo from "../Components/ProjectInfo";
import {useEffect, useRef, useState} from "react";
import SelectPlan from "../Components/SelectPlan";
import CheckResult2 from "../Components/CheckResult2";
import ApiService from "../Service/ApiService";
import {v4} from "uuid";
import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import InternalSummaryPanel from "../Components/InternalSummaryPanel";
import {useUser} from "../Context/UserContext";
import { Radio } from 'antd';
import HecRasHelper from "../Helpers/HecRasHelper";
import CrossSectionFilter from "../Components/CrossSectionFilter";

const enable = true
const time = 0
const noIssueText = 'There is no issue in this check point.'
const showIndicator = ({data}) => {
    try {
        return data?.result?.length > 0 && data?.result?.find(x => x?.data?.length > 0 || !(x?.data))
    }
    catch (exp) {
        return false
    }
}

const request = async ({key, target, projectHash}) => {
    const res = await ApiService.RasCheck.InternalCheck({
        target,
        key: key,
        projectHash
    });

    if(res.success)
        return JSON.parse(res.data)

    throw new Error('Error')
}

const getOperations = () => {
    return [
        {
            title: 'Cross Section',
            children: [
                {title: 'DS Reach Length/River Station', key: 'B6', request: ({key, projectHash}) => request({key, target: 'check_reach_length', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'XS Low Elevation', Component: CheckResult2, key: 'B20', request: ({key, projectHash}) => request({key, target: 'check_flow_contained_2', projectHash}), result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Cross Section Spacing', Component: CheckResult2, key: 'B26', request: ({key, projectHash}) => request({key, target: 'cross_section_spacing', projectHash}), result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Structure',
            children: [
                {title: 'Cont/Exp Ratio around Structure', key: 'B5', request: ({key, projectHash}) => request({key, target: 'check_cont_exp_structure', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                // {title: 'Cont/Exp Ratio around Structure Skew', key: 'B23', request: ({key, projectHash}) => request({key, target: 'check_cont_exp_structure_skew', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Structure Modeling Method', key: 'B7', request: ({key, projectHash}) => request({key, target: 'check_bridge_modelling_method', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Ineffective Area around Structure', key: 'B30', request: ({key, projectHash}) => request({key, target: 'check_structure_overflow', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Transition Coefficient',
            children: [
                {title: 'Contraction/Expansion Coefficient', key: 'B4', request: ({key, projectHash}) => request({key, target: 'check_cont_exp_coeff', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Schematic',
            children: [
                {title: 'Geo Referencing', key: 'B9', request: ({key, projectHash}) => request({key, target: 'check_geo_referencing', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Bank Station', key: 'B10', request: ({key, projectHash}) => request({key, target: 'check_bank_station', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Ratio of Cutline to XS Length', key: 'B11', request: ({key, projectHash}) => request({key, target: 'check_ratio_of_cutline_xs', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Skew Angle', key: 'B12', request: ({key, projectHash}) => request({key, target: 'check_skew_angle', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Intersecting Cross sections', key: 'B15', request: ({key, projectHash}) => request({key, target: 'check_intersecting_cs', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Flow',
            children: [
                {title: 'FW – 100yr Flow Data Consistency', key: 'B13', request: ({key, projectHash}) => request({key, target: 'check_flow_data', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Floodway',
            children: [
                {title: 'Surcharge', Component: CheckResult2, key: 'B1', request: ({key, projectHash}) => request({key, target: 'check_surcharge', projectHash}), result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Encroachment Station Placement', key: 'B2', request: ({key, projectHash}) => request({key, target: 'check_enc_station_placement', projectHash}), Component: CheckResult2, result: {}, enable, time, showIndicator, noIssueText},
                {title: 'Encroachment Method', key: 'B3', request: ({key, projectHash}) => request({key, target: 'check_enc_method', projectHash}), Component: CheckResult2,result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
        {
            title: 'Output',
            children: [
                {title: 'Flow Contained within XS', Component: CheckResult2, key: 'B17', request: ({key, projectHash}) => request({key, target: 'check_flow_contained', projectHash}), result: {}, enable, time, showIndicator, noIssueText},
            ]
        },
    ]
}

export default function InternalCheck2({}) {
    const {user} = useUser()
    const [running, setRunning] = useState(false)
    const {baseProject, compareProject, projectHistory, setProjectHistory, setInternalSelectedId, internalSelectedId} = useProject()
    const [selected, setSelected] = useState({})
    const [selectedChild, setSelectedChild] = useState({})
    const [operations, setOperations] = useState(getOperations())
    const [summary, setSummary] = useState({})

    const parseProject = async () => {
        if(selected && selected.project && selected.plan) {
            const data = {
                project: selected.project.information,
                geometry: selected.plan.geometry,
                flow: selected.plan.flow,
                output: selected.plan.mappedProfiles ?? [],
                plan: selected.plan.plan,
                type: selected.plan.type,
                profileNames: selected.plan.mapProfiles,
                settings: user.settings,
                projectHash: selected.projectHash
            }
            const res = await ApiService.RasCheck.ParseInternal(data)
            if(res.success) {
                const data = JSON.parse(res.data)
                return {...data}
            }
        }
    }

    useEffect(() => {
        if(selected && selected.project && selected.plan) {
            const id = selected.plan.id;
            setInternalSelectedId(id)
            if(id) {
                const history = projectHistory.find(x => x.id === id)
                if(history) {
                    setOperations([
                        ...history.operations
                    ])
                    setSummary(history.summary)
                }
                else {
                    setOperations(getOperations())
                    setSummary({})
                }
            }
        }
    }, [selected])

    const runOperations = async ({key, projectHash}) => {
        setOperations(operations.map(x => ({
            ...x,
            children: x.children.map(y => {
                if(!y.enable)
                    return y;

                return {
                    ...y,
                    status: OPS_STATUS.CHECKING
                }
            })
        })))

        const ops = [...operations]
        for(let i=0; i<ops.length; i++) {
            const children = ops[i].children;

            for(let x=0; x<children.length; x++) {
                let child = children[x];
                try {
                    if(!child.enable)
                        continue

                    let time = new Date();
                    const res = await child.request({key, projectHash});
                    let time2 = new Date();

                    const sec =(time2.getTime() - time.getTime())/1000

                    if(res) {
                        child.status = OPS_STATUS.COMPLETED;
                        child.time = sec;
                        child.result = res;
                        child.enable = false;

                        setOperations(prevState => {
                            prevState[i].children[x] = child;
                            return [...prevState]
                        })
                    }
                }
                catch (exp) {
                    child.status = OPS_STATUS.ERROR;
                    child.result = {};

                    setOperations(prevState => {
                        prevState[i].children[x] = child;
                        return [...prevState]
                    })
                }
            }
        }

        return ops
    }

    return (
        <>
            <BaseLayout>
                <Card>
                    <div style={{display: 'flex', alignItems: 'end', gap: 8, width: '100%'}}>
                        <div style={{minWidth: 354, textAlign: 'end'}}>
                            <Typography.Text style={{marginRight: 8}}>
                                <b>Select Plan</b>
                            </Typography.Text>
                        </div>
                        <div style={{flex: 1}}>
                            <ProjectInfo
                                autoHeight={true}
                                folderName={selected.project?.information?.folderName}
                                title={selected.project?.information.title}
                                descriptions={selected.project?.information.descriptions}
                                planTitle={selected.plan?.plan?.title}
                                version={selected.project?.projectFiles && selected.project?.projectFiles.length > 0 && (
                                    selected.plan?.plan?.version
                                )}
                            />
                            <br/>
                            <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                <SelectPlan
                                    style={{minWidth: 308}}
                                    value={internalSelectedId}
                                    disabled={running}
                                    modelA={baseProject}
                                    modelB={compareProject}
                                    onPlanChanged={({project, plan, model, id, projectHash}) => {
                                        setSelected({
                                            project,
                                            plan,
                                            model,
                                            projectHash
                                        })
                                        setInternalSelectedId(id)
                                    }}
                                />
                                <Button
                                    size={'small'}
                                    type={'primary'}
                                    onClick={
                                        async () => {
                                            const id = selected.plan?.id;

                                            setSelectedChild({x: -1, y: -1})
                                            setSummary({preparing: true})

                                            setRunning(true)
                                            const parsed = await parseProject()
                                            setSummary(parsed.summary)

                                            const ops = await runOperations({
                                                key: parsed.key,
                                                projectHash: selected.projectHash
                                            })
                                            const del = await ApiService.RasCheck.RunComplete(parsed.key)
                                            setRunning(false)

                                            if((ops && ops.length <= 0) || !id)
                                                return

                                            const index = projectHistory.findIndex(x => x.id === id);
                                            if(index < 0) {
                                                setProjectHistory([
                                                    ...projectHistory,
                                                    {
                                                        type: 'internal',
                                                        project: selected,
                                                        date: new Date(),
                                                        id,
                                                        operations: ops,
                                                        summary: parsed.summary
                                                    }
                                                ])
                                            }
                                            else {
                                                let t = [...projectHistory]
                                                t[index] = {
                                                    ...t[index],
                                                    operations: ops,
                                                    summary: parsed.summary
                                                }
                                                setProjectHistory(t)
                                            }
                                        }
                                    }
                                    disabled={running}
                                >
                                    Check
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div style={{display: 'flex', alignItems: 'end', gap: 8, width: '100%', marginTop: 8}}>
                        <div style={{minWidth: 354, textAlign: 'end'}}>
                            <Typography.Text style={{marginRight: 8}}>
                                <b>Select Project Reach</b>
                            </Typography.Text>
                        </div>
                        <CrossSectionFilter type={'check'} csList={selected?.plan?.csList || []} />
                    </div>
                </Card>
                <br/>
                <OperationManager
                    type={'check'}
                    settings={user.settings}
                    showKey={user?.data?.email.includes('esefberfu@gmail.com') || user?.data?.email.includes('ihaltas@gmail.com')}
                    id={selected?.plan?.id}
                    operations={operations}
                    selected={selectedChild}
                    summaryPanel={summary && (() => <InternalSummaryPanel summary={summary} />)}
                />
            </BaseLayout>
        </>
    )
}